import * as React from 'react';
import jamespot, { AudienceAutocomplete } from 'jamespot-user-api';
import { JRCInputAutocomplete } from './JRCInputAutocomplete';
import { FieldValues } from 'react-hook-form';
import { JRCAutocompleteProps } from './JRCInputSelect.types';

const autocompleteAudience = (inputValue: string) =>
    inputValue && inputValue.trim().length > 0
        ? jamespot.audience.autocomplete(inputValue)
        : new Promise<AudienceAutocomplete[]>((resolve) => resolve([]));

export type JRCInputAudienceProps<T extends FieldValues = FieldValues> = JRCAutocompleteProps<T> & {
    multiple?: boolean;
    searchable?: boolean;
};

export function JRCInputAudience<T extends FieldValues = FieldValues>(props: JRCInputAudienceProps<T>) {
    return (
        <JRCInputAutocomplete
            {...props}
            asyncPromise={autocompleteAudience}
            getSearch="title"
            showAsyncResultOnEmptySearch
        />
    );
}
